import { createSlice } from "@reduxjs/toolkit";
import { ApplicationPreviewROWState } from "../types";
import { fetchApplicationPreviewROW } from "./thunk/PreviewROWThunk";

const initialState: ApplicationPreviewROWState = {
  applicationPreview: null,
  loading: false,
  error: null,
};

const PreviewROWSlice = createSlice({
  name: "previewROW",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicationPreviewROW.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplicationPreviewROW.fulfilled, (state, action) => {
        state.loading = false;
        state.applicationPreview = action.payload;
      })
      .addCase(fetchApplicationPreviewROW.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Something went wrong";
      });
  },
});

export default PreviewROWSlice.reducer;
